<template>
  <section class="error__text__modal0009">
      <div class="outer__div" v-for="ErrorDialog in getErrorDialog" v-bind:key="ErrorDialog">
          <span class="error__text__title">{{ErrorDialog.Error__dialog__title}}</span>
          <div class="inner__modal">
              <div class="modal__message">
                  <p>{{ErrorDialog.Error__dialog}}</p>
                  <!-- <p>jdfgfdhjfhlk</p> -->
                  <el-button type="info" plain class="float__right">閉じる</el-button>
              </div>
          </div>
      </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
//import Common from '../../common/CommonFunc.js'
export default {
    name: "error__text__modal0009",
  props: [],
  mounted() {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters("sp_Situation0014", ["getErrorDialog"])
  },
    beforeCreate(){
      //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
      //Common.Session.CheckIsMobile("/sp/0009","/0009"); // MobileScreen Path, WebScreen Path
   }
}
</script>

<style scoped>
@import "0009.css";
@import "../../assets/css/customStyle.css";
</style>